import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [mobileLoginOpen, setMobileLoginOpen] = useState(false);

  const loginDropdownRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleCloseDrawer = () => {
    setIsTermsOpen(false);
    setMobileLoginOpen(false);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        loginDropdownRef.current &&
        !loginDropdownRef.current.contains(event.target)
      ) {
        setIsLoginOpen(false);
      }
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsTermsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsLoginOpen(false);
        setIsTermsOpen(false);
        setIsMenuOpen(false);
        setMobileLoginOpen(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMenuOpen]);

  return (
    <>
      <div className="xl:flex w-full justify-center mainHeader h-24 bg-white shadow-sm fixed top-0 z-20 hidden">
        <div className="px-[70px] w-full">
          <header className="flex justify-between relative py-6 mx-auto items-center h-full w-full border-b border-white/10">
            <div className="flex gap-24 items-center">
              <Link to="/" aria-label="logo-home">
                <img
                  data-aos="fade"
                  src="assets/images/brand_logo.png"
                  alt=""
                  style={{ width: "200px" }}
                />
              </Link>
            </div>
            <ul className="flex gap-10 text-main-black text-base leading-5 font-medium font-inter h-fit items-center">
              <li data-aos="fade">
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li data-aos="fade">
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                  to="/plans"
                >
                  Plans
                </Link>
              </li>

              <li data-aos="fade" className="group relative" ref={dropdownRef}>
                <div
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E] flex gap-2 items-center cursor-pointer"
                  onClick={() => setIsTermsOpen(!isTermsOpen)}
                >
                  Terms &amp; Policies
                  <svg
                    className={`transition-all duration-300 ${isTermsOpen ? "rotate-180" : ""}`}
                    width={10}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div
                  className={`absolute left-0 mt-3 w-[240px] rounded-xl bg-white shadow-xl border border-gray-100 transform transition-all duration-200 origin-top z-50 ${
                    isTermsOpen ? "scale-100 opacity-100" : "scale-95 opacity-0 pointer-events-none"
                  }`}
                >
                  <ul className="py-2">
                    {[
                      { label: "Term Of Use", to: "/term-of-use" },
                      { label: "Shipping & Delivery Policy", to: "/shipping-delivery-policy" },
                      { label: "Privacy Policy", to: "/privacy-policy" },
                      { label: "Cancellation Policy", to: "/cancellation-policy" },
                    ].map((item) => (
                      <li key={item.to}>
                        <Link
                          className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-[#fff6f5] hover:text-[#AF493E] transition-colors duration-150"
                          to={item.to}
                          onClick={() => setIsTermsOpen(false)}
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>

                </div>
              </li>

              <li data-aos="fade">
                <Link
                  to="/contact"
                  className="home-two-nav-item text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                >
                  Contact
                </Link>
              </li>
            </ul>

            <div className="flex gap-7 items-center">
              <div ref={loginDropdownRef} className="relative">
                <button
                  onClick={() => setIsLoginOpen(!isLoginOpen)}
                  className="home-two-btn-bg py-2.5 group bg-[#AF493E] flex items-center gap-2"
                >
                  <span className="text-base text-white group-hover:text-[#AF493E] transition-all duration-300 font-semibold font-inter relative z-10">
                    Login
                  </span>
                  <svg
                    className={`relative z-10 transition-transform duration-300 ${isLoginOpen ? "rotate-180" : ""}`}
                    width={10}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="white"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                <div
                  className={`absolute right-0 mt-3 w-[220px] rounded-xl bg-white shadow-xl border border-gray-100 transform transition-all duration-200 origin-top z-50 ${
                    isLoginOpen ? "scale-100 opacity-100" : "scale-95 opacity-0 pointer-events-none"
                  }`}
                >
                  <div className="py-2">
                    <a
                      href="/login.html"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => setIsLoginOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-[#fff6f5] hover:text-[#AF493E] transition-colors duration-150"
                    >
                      {/* Customer Icon */}
                      <svg className="w-4 h-4 shrink-0 text-[#AF493E]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
                      </svg>
                      Customer Login
                    </a>

                    <div className="mx-4 border-t border-gray-100" />

                    <a
                      href="https://portal.carenova.in/"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => setIsLoginOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-[#fff6f5] hover:text-[#AF493E] transition-colors duration-150"
                    >
                      {/* Partner Icon */}
                      <svg className="w-4 h-4 shrink-0 text-[#AF493E]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      Partner / Leader Login
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </header>
        </div>
      </div>

      <header className="flex xl:hidden flex-col relative">
        <div className="h-16 bg-white flex items-center justify-between fixed top-0 left-0 z-50 w-full px-2.5 shadow-sm">
          <a href="/">
            <img
              data-aos="fade"
              src="assets/images/brand_logo.png"
              alt="logo"
              style={{ width: "200px" }}
            />
          </a>

          <button
            aria-label="mobile-Menu"
            className="text-black w-6 h-6 toggle_nav_menu"
            onClick={toggleMenu}
          >
            {!isMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path fill="#000000" d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Drawer */}
        <div
          className={`fixed top-16 h-screen w-full overflow-y-scroll bg-white z-50 transition-all duration-300 ${
            isMenuOpen ? "left-0" : "-left-full"
          }`}
        >
          <div className="flex gap-8 flex-col px-5 py-5">

            {/* Nav Links */}
            <ul className="flex gap-5 flex-col text-black text-base leading-5 font-medium font-inter">
              <li>
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                  to="/"
                  onClick={handleCloseDrawer}
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                  to="/plans"
                  onClick={handleCloseDrawer}
                >
                  Plans
                </Link>
              </li>

              {/* Mobile Terms Accordion */}
              <li>
                <div
                  className="flex w-full items-center justify-between cursor-pointer"
                  onClick={() => setIsTermsOpen(!isTermsOpen)}
                >
                  <span className="home-two-nav-item no-underline text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]">
                    Terms &amp; Policies
                  </span>
                  <svg
                    className={`transition-all duration-300 ${isTermsOpen ? "rotate-180" : ""}`}
                    width={10}
                    height={10}
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 2L9.5 8L17 2" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>

                <div className={`transition-all duration-300 overflow-hidden ${isTermsOpen ? "max-h-60 mt-2" : "max-h-0"}`}>
                  <ul className="bg-[#fff6f5] rounded-lg px-4 py-3 space-y-2">
                    {[
                      { label: "Term Of Use", to: "/term-of-use" },
                      { label: "Shipping & Delivery Policy", to: "/shipping-delivery-policy" },
                      { label: "Privacy Policy", to: "/privacy-policy" },
                      { label: "Cancellation Policy", to: "/cancellation-policy" },
                    ].map((item) => (
                      <li key={item.to}>
                        <Link
                          onClick={handleCloseDrawer}
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#AF493E] w-fit before:border-[#AF493E] font-normal text-sm block py-1"
                          to={item.to}
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              <li>
                <Link
                  to="/contact"
                  onClick={handleCloseDrawer}
                  className="home-two-nav-item text-black pb-[1px] leading-5 font-inter relative delay-200 hover:text-[#AF493E] before:border-[#AF493E]"
                >
                  Contact
                </Link>
              </li>
            </ul>

            {/* Mobile Login Accordion */}
            <div>
              <button
                onClick={() => setMobileLoginOpen(!mobileLoginOpen)}
                className="home-two-btn-bg py-2.5 group bg-[#AF493E] flex items-center gap-2 w-fit"
              >
                <span className="text-base text-white font-semibold font-inter relative z-10">
                  Login
                </span>
                <svg
                  className={`relative z-10 transition-transform duration-300 ${mobileLoginOpen ? "rotate-180" : ""}`}
                  width={10}
                  height={10}
                  viewBox="0 0 19 10"
                  fill="none"
                >
                  <path d="M2 2L9.5 8L17 2" stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {/* Mobile Login Options */}
              <div className={`transition-all duration-300 overflow-hidden ${mobileLoginOpen ? "max-h-40 mt-2" : "max-h-0"}`}>
                <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden w-[220px]">
                  <a
                    href="/login.html"
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleCloseDrawer}
                    className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-[#fff6f5] hover:text-[#AF493E] transition-colors duration-150"
                  >
                    <svg className="w-4 h-4 shrink-0 text-[#AF493E]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
                    </svg>
                    Customer Login
                  </a>
                  <div className="mx-4 border-t border-gray-100" />
                  <a
                    href="https://portal.carenova.in/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleCloseDrawer}
                    className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-[#fff6f5] hover:text-[#AF493E] transition-colors duration-150"
                  >
                    <svg className="w-4 h-4 shrink-0 text-[#AF493E]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    Partner / Leader Login
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
